<!-- -->
<template>
  <div class="banner">
    <img
      class="banner-img"
      :src="topNav.imgUrl"
      :alt="topNav.name"
      v-if="topNav.imgUrl"
    />
    <div class="empty" v-else></div>
  </div>
</template>

<script>
import { Store } from "@/store/index.js";
import { mapState } from "pinia";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(Store, ["navList"]),
    // 扁平化导航条
    nav() {
      return this.flatNav.find((ele) => ele.id == this.$route.params.id);
    },
    // 扁平化导航条
    flatNav() {
      return this.navList.flatMap((ele) => [ele, ...ele.children]);
    },
    topNav() {
      const first = this.flatNav.find((ele) => ele.id == this.$route.params.id);
      if (!first) return [];
      // 若为二级字典，则反找一级字典的children
      if (first.level == 2) {
        return this.navList.find((ele) => ele.code == first.parentCode);
      }
      return first;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.banner-img {
  width: 100%;
  height: 460px;
  object-fit: cover;
}
.empty {
  height: 70px;
}
</style>
